import { useContext, useEffect } from "react";
import ApplicantAuthContext from "../../store/applicantStore/applicant-auth-context";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import useHttpFetch from "../../hooks/useHttpFetch";
import LoadingOverLoadedPage from "../../Components/UI/LoadingOverLoadedPage/LoadingOverLoadedPage";
import { Helmet } from "react-helmet-async";

const IsLoggedInInApplicant = () => {
  const { clientAuthInfo, setClientAuthInfo } = useContext(ApplicantAuthContext);
  const navigate = useNavigate();
  const { sendRequest } = useHttpFetch(false, "Applicant");
  const location = useLocation();

  useEffect(() => {
    const getAuthOnLoad = async () => {
      const verifyReqOptions = {
        url: `CheckAccess`,
        noMiddleUrl: true,
      };

      const authRes = await sendRequest(verifyReqOptions);
      if (authRes?.resIsOk && authRes?.response?.userType?.toLowerCase()?.includes("applicant")) {
        setClientAuthInfo((ps) => ({
          ...ps,
          isLoggedIn: true,
          cellphone: authRes?.response?.cellphone.replace("+98", "0"),
          nationalCode: authRes?.response?.nationalCode,
          firstName: authRes?.response?.firstName,
          lastName: authRes?.response?.lastName,
        }));
        navigate(
          `/personnel-information/${location?.pathname?.includes("333status") ? "333status" : "add"}/${
            authRes?.response?.firstName
          }/${authRes?.response?.lastName}/${
            authRes?.response?.nationalCode
          }/${authRes?.response?.cellphone.replace("+98", "0")}`,
        );
      } else {
        navigate("/applicant-information/login");
      }

      setClientAuthInfo((ps) => ({
        ...ps,
        isLoading: false,
      }));
    };
    getAuthOnLoad();
  }, []);

  return (
    <>
      <Helmet>
        <meta name="description" content="Applicant Information" />
        <meta property="og:title" content="Pergas Teb - Applicant" />
        <meta property="og:description" content="Applicant Information" />
        <meta name="twitter:title" content="Pergas Teb - Applicant" />
        <meta name="twitter:description" content="Applicant Information" />
        <title>Pergas Teb - Applicant</title>
      </Helmet>
      {clientAuthInfo.isLoading ? <LoadingOverLoadedPage /> : <Outlet />}
    </>
  );
};

export default IsLoggedInInApplicant;
